import evAPI from '@util/api/ev';
import { client } from './contentfulClient';
import { fixLocale } from './page';

export interface Path {
  tags: any;
  current: string;
  title: string;
  id: string;
}

const api = new evAPI();

export const getNeighborhoodHomepageData = async (
  locale: string,
  slug: string,
  preview?: boolean,
): Promise<any> => {
  if (locale == null || locale == 'en') locale = 'en-US';
  const clientEntries = await client().getEntries({
    content_type: 'neighborhoodHomepage',
    'fields.neighborhood.fields.slug': slug,
    'fields.neighborhood.sys.contentType.sys.id': 'neighborhoodSingle',
    include: 5,
    locale: fixLocale(locale),
  });
  return clientEntries;
};

export const getDefaultNeighborhoodContactUsComponentData = async (
  locale: string,
  preview?: boolean,
): Promise<any> => {
  if (locale == null || locale == 'en') locale = 'en-US';
  const contactForm = await client().getEntries({
    'sys.id': '2kIbstc6fCkEEfjEzpT5Vu',
    include: 5,
    limit: 1,
    locale: fixLocale(locale),
  });
  if (contactForm?.total === 0) {
    return null;
  }
  return contactForm.items[0];
};

export const getNeighborhoodsOfShopData = async (tags: string[]): Promise<any> => {
  const clientEntries = await client().getEntries({
    content_type: 'neighborhoodHomepage',
    include: 10,
    'metadata.tags.sys.id[in]': tags,
    order: ['-sys.createdAt'],
  });
  return clientEntries;
};
